import React from 'react'
import QAImg from '../../images/qa/qa.jpg'
import QAImg2 from '../../images/qa/qa2.png'
import { motion } from 'framer-motion'
import AnimatedElement from '../../components/AnimatedElement'
import RevealText from '../../components/TextReveal2'
import Quality from '../../images/qa/Quality3.jfif'
function QA() {
    const images = [
        QAImg,
        QAImg2
    ]
    return (
        <div className='bg-gray-100 h-auto overflow-hidden'>
            <div className='w-full h-screen relative bg-black flex items-center justify-center overflow-hidden'>

                <img
                    alt='qa-bg'
                    className='absolute inset-0 w-full h-full object-cover opacity-80'
                    src={Quality}
                />

                <div className='relative z-10'>
                    <RevealText
                        text='Quality Department'
                        css='text-[3rem] after:bg-black max-sm:text-[1.5rem] bg-black p-3 bg-opacity-60 text-white uppercase font-bold'
                    />
                </div>

            </div>
            <AnimatedElement direction='from-left' delayAn='0.2'>
                <div className='flex px-[100px] max-sm:px-3 max-sm:flex-col max-sm:mt-6 items-center justify-center'>
                    <div className='flex-[3] text-justify '>
                        <RevealText text='The Quality' css='text-[2rem] after:bg-black max-sm:text-[1.2rem] font-bold uppercase' />
                        <span>

                            department is the backbone of our commitment to delivering reliable products and services. With a team of highly skilled professionals, we ensure that every process meets stringent quality standards. By fostering continuous improvement and extending quality practices across the organization.
                        </span>
                        <p className='font-medium mt-3 '>The Quality department ensures all processes are carried out in full compliance with applicable standards.</p>
                    </div>

                    <div className='flex-1'>
                        <img alt='qa-img' src={QAImg2} />
                    </div>

                </div>
            </AnimatedElement>
        </div>
    )
}

export default QA